<script lang="ts" setup>
import HenceText from '@/pages/hence/components/HenceText.vue'
import PageLink from '@/pages/hence/components/PageLink.vue'
import Banner from '@/pages/hence/components/Banner.vue'
import List1 from '@/pages/hence/components/List1.vue'
import List2 from '@/pages/hence/components/List2.vue'
import List3 from '@/pages/hence/components/List3.vue'
import Recipe from '@/pages/hence/components/Recipe.vue'
import Experience from '@/pages/hence/components/Experience.vue'
import Article from '@/pages/hence/components/Article.vue'
import Podcast from '@/pages/hence/components/Podcast.vue'
import Newsletter from '@/pages/hence/components/Newsletter.vue'
import { usePageStore, useArticleStore } from '@/stores'
import _ from 'lodash'
import useSeo from './seo'

const pageStore = usePageStore()
const articleStore = useArticleStore()
await articleStore.fetchArticleCategories('projectCategories', {
  className: 'articleProject'
})
await pageStore.fetchGetHence()
const henceBanners = computed(() => pageStore.henceBanners)
const henceMustReads = computed(() => pageStore.henceMustReads)
const henceRecipe = computed(() => pageStore.henceRecipe)
const henceArticles = computed(() => _.chunk(pageStore.henceArticles, 3))
const henceLifestyles = computed(() => pageStore.henceLifestyles)
useSeo()
</script>

<template>
  <section class="hence">
    <!-- <HenceText /> -->
    <PageLink />
    <Banner :banners="henceBanners" v-if="henceBanners.length > 0" />
    <List1 :items="henceArticles.length > 0 ? henceArticles[0] : []" />
    <List2 :items="henceArticles.length > 1 ? henceArticles[1] : []" />
    <List3 :items="henceArticles.length > 2 ? henceArticles[2] : []" />
    <Recipe :data="henceRecipe" v-if="henceRecipe?.recipe !== null" />
    <Experience class="hence__full" :items="henceLifestyles" v-if="henceLifestyles.length > 0" />
    <Article :items="henceMustReads" />
    <!-- <Podcast /> -->
    <Newsletter class="hence__full" />
  </section>
</template>

<style lang="scss" scoped>
.hence {
  @include max-media(767) {
    position: relative;
    z-index: 2;
    transform: translateY(toRem(100));
    margin-top: toRem(-100);
  }

  &__full {
    margin-left: toRem(-24);
    margin-right: toRem(-24);
  }
}
</style>
